import { Button, Stack } from '@mui/material'
import React, { useState } from 'react'
import { SourceDialog } from './SourceDialog'
import CodeIcon from '@mui/icons-material/Code';
import { Box } from '@mui/system';

export const PreviewPanel = (props) => {
  const { htmlText } = props
  const styleText = "<style>body{ display: flex; justify-content: center; align-items: center; }table,th,td{border:solid 1px gray}</style>"
  console.log(htmlText)
  console.log(styleText)
  // for SourceDialog
  const [dialogIsOpen, setDialogIsOpen] = useState(false)
  const openDialog = () => {
    setDialogIsOpen(true)
  }
  const closeDialog = () => {
    setDialogIsOpen(false)
  }

  return (
    <>
      <Stack sx={{ display: "flex", justifyContent: "center" }}>
        <iframe
          srcDoc={`${styleText}<body>\n${htmlText}</body>`}
          frameBorder="0"
          style={{ width: "100%", minHeight: "460px", padding: "10px", border: "solid 1px lightgray", borderRadius: "15px" }}
        >
        </iframe>
        <Box sx={{ display: "flex", justifyContent: "center", padding: "20px" }}>
          <Button
            size="large"
            variant="contained"
            startIcon={<CodeIcon />}
            onClick={openDialog}
          >
            View Code
          </Button>
        </Box>
      </Stack>
      <SourceDialog
        htmlText={htmlText}
        isOpen={dialogIsOpen}
        closeDialog={closeDialog}
      />
    </>
  )
}
